const PERMISSION_KEY= "personalize:ta_indicator_config";
const PAGE_URL = {
    TA_INDICATOR_CONFIG_PAGE: "/admin/personalize/ta-indicator-config"
}

export {PERMISSION_KEY, PAGE_URL}

